import API from './API';

export default class UnitOfMeasureAPI extends API {
  constructor(parameters = {}) {
    super('/UnitOfMeasure', parameters);
  }

  getUnitOfMeasure() {
    return this.submit("get", `${this.endpoint}`);
  }
}
